import { openkit } from "../../library/database";

export const addVehicleToCart = async (
  product,
  info,
  extraReservationConfig,
  clientRequest,
  setAddedToCart,
  driverInfo
) => {
  const cartItem = {
    type: "rentacar",
    product_id: product.id,
    client_id: info.user.id,
    pickup_loc: info.rentacar?.pickupLoc,
    // pickup_date: info.rentacar?.pickup_date?.format(),
    // pickup_time: info.rentacar?.pickup_time,
    return_loc: info.rentacar?.returnLoc,
    // return_date: info.rentacar?.return_date?.format(),
    // return_time: info.rentacar?.return_time,
    ren_typology: info.rentacar?.typology,
    ren_conditions:
      product.ren_conditions && product.ren_conditions[info.rentacar?.typology],
    extras: extraReservationConfig,
    request: clientRequest,
    reservation_time_range: info.rentacar?.reservation_time_range,
    ren_driver_info: driverInfo,
    ren_transfer_loc: info.rentacar?.transferLoc,
    ren_transfer_time: info.rentacar?.transferTime,
  };

  try {
    const resp = await openkit.custom.execute(
      "post",
      "create-reservation",
      null,
      {
        cartItem,
      }
    );
    if (Object.keys(resp).length > 0) setAddedToCart(true);

    return resp;
  } catch (error) {
    console.log("error :>> ", error);
  }

  // try {
  //   await openkit.data.create("c_reservation_lines", cartItem);
  // } catch (error) {
  //   console.log(error);
  // }
};
